var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_103",
    "data-name": "\\uADF8\\uB8F9 103",
    transform: "translate(-940 -147)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_86",
    "data-name": "\\uC0AC\\uAC01\\uD615 86",
    width: 32,
    height: 32,
    transform: "translate(940 147)",
    fill: "#ff2727",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "flag",
    d: "M65,60a1,1,0,0,1-1-1V34.258a1.5,1.5,0,0,1,.744-1.295C65.5,32.524,67.024,32,70,32a23.253,23.253,0,0,1,7.222,1.73A17.508,17.508,0,0,0,82,35a11.49,11.49,0,0,0,4.438-.906A1.125,1.125,0,0,1,88,35.13V48.84a1.25,1.25,0,0,1-.75,1.144A13.618,13.618,0,0,1,82,51a25.968,25.968,0,0,1-5.4-.919A30.587,30.587,0,0,0,70,49a10.47,10.47,0,0,0-4,.569V59A1,1,0,0,1,65,60Z",
    transform: "translate(880 117)",
    fill: "#ff4040"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.3f707d531cfc231a1d1c4f063636dd02.svg";
export { ForwardRef as ReactComponent };